const React = require('react');
const upperFirst = require("mn-utils/upperFirst");
const formatTime = require("mn-utils/formatTime");
const Tooltip = require('../../../../../dumb/Tooltip/B');
const RefTableRow = require('../../../../../dumb/TableRow/RefTableRow');

module.exports = ({data, index}) => {
  return (
    <RefTableRow
      className="(wmin130|w1/5)>1"
      index={index}
    >
      <div>
        <Tooltip className="fhaS">
          {data.organization_name}
        </Tooltip>
      </div>
      <div>
        <Tooltip className="fhaS">
          {data.email}
        </Tooltip>
      </div>
      <div>
        <Tooltip title={formatTime.getRFC3339(data.created_at)} className="fhaS">
          <div>{formatTime(data.created_at, '{dd} {mmm}, {yyyy}', true)}</div>
        </Tooltip>
      </div>
      <div>
        {data.onboarding_status ? data.onboarding_status.split('_').map(upperFirst).join(' ') : ''}
      </div>
      <div>
        {data.lifeflow ? data.lifeflow.split('_').map(upperFirst).join(' ') : ''}
      </div>
    </RefTableRow>
  )
}
